interface SessionTokens {
    accessToken: string;
    refreshToken?: string;
    idToken: string;
}

// Fire-and-forget wrappers — auth must not fail if the session endpoint is unavailable.
// baseURL must be the runtime per-tenant API origin (e.g. https://livoniadev.liveline.cloud/customer-portal/api/v1)
// NOT process.env.REACT_APP_SERVER_URL — that env var is dead code and resolves to an internal hostname.

export async function postSession(tokens: SessionTokens, baseURL: string): Promise<void> {
    try {
        await fetch(`${baseURL}/session`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(tokens),
        });
    } catch (e) {
        console.error('postSession failed', e);
    }
}

export async function patchSession(tokens: Partial<SessionTokens>, baseURL: string): Promise<void> {
    try {
        await fetch(`${baseURL}/session`, {
            method: 'PATCH',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(tokens),
        });
    } catch (e) {
        console.error('patchSession failed', e);
    }
}

export async function deleteSession(baseURL: string): Promise<void> {
    try {
        await fetch(`${baseURL}/session`, {
            method: 'DELETE',
            credentials: 'include',
        });
    } catch (e) {
        console.error('deleteSession failed', e);
    }
}
